<template>
  <v-col cols="12">
    <v-card class="mx-4">
      <v-tabs v-model="tab" bg-color="primary">
        <v-tab value="zero">{{ t('Calendario') }}</v-tab>
        <v-tab value="one">{{ t('Teoría') }}</v-tab>
        <v-tab value="two">{{ t('Práctica') }}</v-tab>
        <v-tab value="three">{{ t('Total') }}</v-tab>
        <v-tab value="four">{{ t('Cuestionarios') }}</v-tab>
        <v-tab value="respuestas">{{ t('Respuestas') }}</v-tab>
        <v-tab value="five">{{ t('Encuestas') }}</v-tab>
      </v-tabs>
      <v-tabs-window v-model="tab">
        <v-tabs-window-item value="zero">
          <v-toolbar flat>
            <v-toolbar-title>{{ t('Reservas') }}</v-toolbar-title>
            <v-btn :to="`/reservas`" prepend-icon="mdi-calendar-plus">{{ t('Tus_reservas') }}</v-btn>
            <ExportExcel :nombre="t('.csv')" :dataItems="formattedTimeSlots" />
          </v-toolbar>
          <v-text-field class="mx-4 mt-4" v-model="search" label="Cerca" prepend-inner-icon="mdi-magnify" single-line
            variant="outlined" hide-details></v-text-field>
          <v-data-table-virtual :headers="headersr" :items="formattedTimeSlots" :search="search" :loading="loading">
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
            </template>
          </v-data-table-virtual>
        </v-tabs-window-item>
        <v-tabs-window-item value="one">
          <v-toolbar flat>
            <v-toolbar-title>{{ t('Alumnos') }}</v-toolbar-title>
            <DistribucionNotas :data="tablaTeoria" variable="nota_media" :bins="8" />
            <ExportExcel :nombre="t('.csv')" :dataItems="tablaTeoria" />
          </v-toolbar>
          <v-text-field class="mx-4 mt-4" v-model="search" label="Cerca" prepend-inner-icon="mdi-magnify" single-line
            variant="outlined" hide-details></v-text-field>
          <v-data-table-virtual :headers="headerst" :items="tablaTeoria" :search="search" :loading="loading">
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
            </template>
          </v-data-table-virtual>
        </v-tabs-window-item>
        <v-tabs-window-item value="two">
          <v-toolbar flat>
            <v-toolbar-title>{{ t('Alumnos') }}</v-toolbar-title>
            <DistribucionNotas :data="tablaPractica" variable="nota_media" :bins="8" />
            <ExportExcel :nombre="t('.csv')" :dataItems="tablaPractica" />
          </v-toolbar>
          <v-text-field class="mx-4 mt-4" v-model="search" label="Cerca" prepend-inner-icon="mdi-magnify" single-line
            variant="outlined" hide-details></v-text-field>
          <v-data-table-virtual :headers="headersp" :items="tablaPractica" :search="search" :loading="loading">
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
            </template>
          </v-data-table-virtual>
        </v-tabs-window-item>
        <v-tabs-window-item value="three">
          <v-toolbar flat>
            <v-toolbar-title>{{ t('Nota_final') }}</v-toolbar-title>
            <DistribucionNotas :data="tablaNotas" variable="nota_final" :bins="8" />
            <ExportExcel :nombre="t('.csv')" :dataItems="tablaNotas" />
          </v-toolbar>
          <v-text-field class="mx-4 mt-4" v-model="search" label="Cerca" prepend-inner-icon="mdi-magnify" single-line
            variant="outlined" hide-details></v-text-field>
          <v-data-table-virtual :headers="headersg" :items="tablaNotas" :search="search" :loading="loading">
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
            </template>
          </v-data-table-virtual>
        </v-tabs-window-item>
        <v-tabs-window-item value="four">
          <v-toolbar flat>
            <v-toolbar-title>{{ t('Alumnos') }}</v-toolbar-title>
            <ExportExcel :nombre="t('.csv')" :dataItems="tablaCuestionarios" />
          </v-toolbar>
          <v-text-field class="mx-4 mt-4" v-model="search" label="Cerca" prepend-inner-icon="mdi-magnify" single-line
            variant="outlined" hide-details></v-text-field>
          <v-data-table-virtual :headers="headersc" :items="tablaCuestionarios" :search="search" :loading="loading">
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
            </template>
          </v-data-table-virtual>
        </v-tabs-window-item>
        <v-tabs-window-item value="respuestas">
          <v-toolbar flat>
            <v-toolbar-title>{{ t('Respuestas') }}</v-toolbar-title>
            <ExportExcel :nombre="t('.csv')" :dataItems="tablaRespuestas" />
          </v-toolbar>
          <v-text-field class="mx-4 mt-4" v-model="search" label="Cerca" prepend-inner-icon="mdi-magnify" single-line
            variant="outlined" hide-details />
          <v-data-table-virtual :headers="headersRespuestas" :items="tablaRespuestas" :search="search"
            :loading="loadingRespuestas">
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@10" />
            </template>
          </v-data-table-virtual>
        </v-tabs-window-item>
        <v-tabs-window-item value="five">
          <v-toolbar flat>
            <v-toolbar-title>{{ t('Encuestas') }}</v-toolbar-title>
            <ExportExcel :nombre="t('.csv')" :dataItems="tablaEncuestas" />
          </v-toolbar>
          <v-text-field class="mx-4 mt-4" v-model="search" label="Cerca" prepend-inner-icon="mdi-magnify" single-line
            variant="outlined" hide-details></v-text-field>
          <v-data-table-virtual :headers="headerse" :items="tablaEncuestas" :search="search" :loading="loading">
            <template v-slot:[`item.valor`]="{ item }">
              <div v-if="item.tipo === 'escala'" class="text-center">
                <!-- Leemos item.valor (un número como 3.5) y lo pasamos al v-rating -->
                <v-rating :model-value="item.valor" half-increments hover readonly size="20"></v-rating>
                <pre>{{ item.valor }}</pre>
              </div>
              <div v-else>
                <!-- Para otros casos (texto, numero, decimal), lo mostramos en texto -->
                {{ item.valor }}
              </div>
            </template>
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
            </template>
          </v-data-table-virtual>
        </v-tabs-window-item>
      </v-tabs-window>
    </v-card>
  </v-col>
</template>

<script setup>
import { onMounted, ref, computed, watch } from 'vue';
import ExportExcel from './ExportExcel.vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { format } from 'date-fns'; // Importa la función format
import DistribucionNotas from './DistribucionNotas.vue';
import { useCursosStore } from '@/stores/cursos';
const cursosStore = useCursosStore();

const { t } = useI18n();
const route = useRoute();
const loading = ref(true);
const tab = ref(null);
const cursoId = ref(route.params.uid);
const search = ref('');

const headerst = ref([
  { title: t('Nombre'), key: 'nombre' },
  { title: t('Apellidos'), key: 'apellidos' },
  { title: t('Completado'), key: 'completado' },
  { title: t('Nota'), key: 'nota_media' },
  { title: t('Puntos'), key: 'suma_puntaje' },
  { title: t('Intentos'), key: 'suma_max_intento' },
]);

const headersp = ref([
  { title: t('Nombre'), key: 'nombre' },
  { title: t('Apellidos'), key: 'apellidos' },
  { title: t('Completado'), key: 'completado' },
  { title: t('Nota'), key: 'nota_media' },
  { title: t('Puntos'), key: 'suma_puntaje' },
  { title: t('Docente'), key: 'docente_ap' },
  { title: t('Intentos'), key: 'suma_max_intento' },
]);

const headersg = ref([
  { title: t('Nombre'), key: 'nombre' },
  { title: t('Apellidos'), key: 'apellidos' },
  { title: t('Nota'), key: 'nota_final' },
  { title: t('Puntos'), key: 'nota_final_puntos' },
  { title: t('Fecha'), key: 'fecha' },
]);

const headersc = ref([
  { title: t('Cuestionario'), key: 'cuestionario_titulo' },
  { title: t('Nombre'), key: 'nombre' },
  { title: t('Apellidos'), key: 'apellidos' },
  { title: t('Nota'), key: 'nota' },
  { title: t('Intentos'), key: 'max_intento' },
  { title: t('Docente'), key: 'docente_ap' },
  { title: t('Fecha'), key: 'fecha_oficial' },
]);

const headersr = ref([
  { title: t('Fecha_de_inicio'), key: 'fechaInicio' },
  { title: t('Hora_de_inicio'), key: 'horaInicio' },
  { title: t('Fecha_de_fin'), key: 'fechaFin' },
  { title: t('Hora_de_fin'), key: 'horaFin' },
  { title: t('Alumnos'), key: 'extendedProps.emailsAlumnos' },
  { title: t('Docentes'), key: 'extendedProps.emailsDocentes' },
]);

const headerse = ref([
  { title: t('Variable'), key: 'variable' },
  { title: t('Etiqueta'), key: 'etiqueta' },
  { title: t('Valor'), key: 'valor' },
  { title: t('Respuestas'), key: 'respuestas' },
]);

const headersRespuestas = ref([
  { title: t('Cuestionario'), key: 'cuestionario_titulo' },
  { title: t('Pregunta'), key: 'pregunta' },
  { title: t('Nombre'), key: 'nombre' },
  { title: t('Apellidos'), key: 'apellidos' },
  { title: 'Email', key: 'email' },
  { title: t('Intentos'), key: 'intento' },
  { title: t('Respuesta'), key: 'respuesta' },
  { title: t('Docente'), key: 'docente' },
  { title: t('Fecha'), key: 'fecha_respuesta' },
]);

const tablaEncuestas = computed(() => cursosStore.tablaEncuestas);
const tablaCuestionarios = computed(() => cursosStore.tablaCuestionarios);
const tablaTeoria = computed(() => cursosStore.tablaTeoria);
const tablaPractica = computed(() => cursosStore.tablaPractica);
const tablaNotas = computed(() => cursosStore.tablaNotas);
const timeSlots = computed(() => cursosStore.timeSlotsCurso);
const tablaRespuestas = computed(
  () => cursosStore.tablaRespuestas
);

const loadingRespuestas = computed(
  () => cursosStore.loadingRespuestas
);

const respuestasCargadas = ref(false);

watch(tab, async (nuevoTab) => {
  if (
    nuevoTab === 'respuestas' &&
    !respuestasCargadas.value
  ) {
    await cursosStore.fetchRespuestasCurso(cursoId.value);
    respuestasCargadas.value = true;
  }
});

const formatDates = (slots) => {
  return slots.map(slot => ({
    fechaInicio: format(new Date(slot.inicio), 'yyyy-MM-dd'),
    horaInicio: format(new Date(slot.inicio), 'HH:mm'),
    fechaFin: format(new Date(slot.fin), 'dd/MM/yyyy'),
    horaFin: format(new Date(slot.fin), 'HH:mm'),

    nombreSimulador: slot.simulador.nombre,
    title: slot.simulador.nombre + ' (' + slot.curso_titulo + ')',
    start: slot.inicio,
    end: slot.fin,
    extendedProps: {
      emailsAlumnos: slot.alumnos.map(alumno => alumno.email).join(', '),
      emailsDocentes: slot.docentes.map(docente => docente.email).join(', '),
      curso: slot.curso,
      curso_titulo: slot.curso_titulo,
    }
  }));
};

const formattedTimeSlots = computed(() => formatDates(timeSlots.value));

const fetchAlumnes = async () => {
  loading.value = true;
  await cursosStore.fetchAlumnosTotal(cursoId.value);
  loading.value = false;
};

onMounted(() => {
  fetchAlumnes();
});
</script>
